import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { TrlTextField } from '»components/atoms/Inputs';
import { useCurrentPage, useDotsNotCommas } from '»utils/customHooks';
import { TrlFormattedNumberPlain } from '»utils/i18n';

import {
  ContainerLeft,
  ContainerRight,
  ContainerStyled,
} from './TrlPrimaryInputData.styles';

export const TrlPrimaryInputData = ({ ...rest }) => {
  const {
    values: { inputQuantity, inputPrice },
    dataItem: { trancheType, price, subscriptionPrice, currency },
  } = rest;

  const { replaceCommasWithDots } = useDotsNotCommas();
  const { isMarketPrimaryPage, isTradingPrimaryPage, isFundsListPage } =
    useCurrentPage();

  return (
    <ContainerStyled id="divInputData">
      <ContainerLeft>
        <TrlTextField
          name="inputQuantity"
          type="text"
          label={
            <FormattedMessage
              id={`${
                trancheType === 'R' && !isFundsListPage
                  ? 'TRLT_UI-AMOUNT'
                  : 'TRLT_UI-QUANTITY'
              }`}
            />
          }
          value={inputQuantity}
          additionalFunc={(event) => {
            replaceCommasWithDots({
              inputName: 'inputQuantity',
              inputValue: event.target.value,
            });
          }}
        />
      </ContainerLeft>
      <ContainerRight>
        {isMarketPrimaryPage || isTradingPrimaryPage ? (
          <TrlTextField
            name="inputPrice"
            type="text"
            label={<FormattedMessage id="TRLT_UI-PRICE" />}
            value={trancheType === 'R' ? null : inputPrice}
            disabled={trancheType === 'R' || (trancheType === 'B' && !!price)}
            additionalFunc={(event) => {
              replaceCommasWithDots({
                inputName: 'inputPrice',
                inputValue: event.target.value,
              });
            }}
          />
        ) : (
          <TrlTextField
            name="amount"
            type="text"
            label={<FormattedMessage id="TRLT_UI-AMOUNT" />}
            value={`${TrlFormattedNumberPlain(
              inputQuantity * subscriptionPrice,
              2,
            )} ${currency}`}
            disabled
          />
        )}
      </ContainerRight>
    </ContainerStyled>
  );
};

TrlPrimaryInputData.propTypes = {
  values: PropTypes.object,
};
